import { HttpClient } from '@angular/common/http';
import { TipoSucursal } from './../modelos/tipoSucursal.model';
// Imports
import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
// Observable
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
// Modelos
import { Paises } from '../modelos/paises.model';
import { PaisesDB } from '../modelos/paisesdb.model';
import { IRol } from './../modelos/rol.model';
import { IUsuario } from './../modelos/usuario.model';
import { IColaborador } from './../modelos/colaborador.model';
import { IMiembro } from './../modelos/miembro.model';


import firebase from 'firebase';
@Injectable()
export class EmpresaService {

  constructor(
    private db: AngularFirestore,
    private http: HttpClient
  ) { }

  public miembro: BehaviorSubject<String> = new BehaviorSubject<String>('');
  public pais: any;
  public organizacion: any;



  // ELiminar usuario de la autenticacion
  deleteUserFromAuth(uid: string): Observable<any> {
    return this.http.post('https://us-central1-am-cham.cloudfunctions.net/EliminarUserAuth', { uid: uid });
  }
  // Traer tipos de sucursales
  getTipoSucursales(): Observable<TipoSucursal[]> {
    return this.db.collection<TipoSucursal>('tipoSucursal').snapshotChanges().pipe(
      map(actions => actions.filter(a => {
        return a.payload.doc.data();
      }).map(a => {
        const info = a.payload.doc.data();
        const id = a.payload.doc.id;
        const data: TipoSucursal = {
          key: id,
          codigo_tipo_sucursal: info.codigo_tipo_sucursal,
          descripcion: info.descripcion
        };
        return data;
      }))
    );
  }
  // Traer miembro por ID
  getMemberById(key: string): Observable<IMiembro[]> {
    return this.db.collection<IMiembro>('miembros', ref => ref.where('key', '==', key)).snapshotChanges().pipe(
      map(actions => actions.filter(a => {

        return !a.payload.doc.data().es_eliminado;
      }).map(a => {
        const _data = a.payload.doc.data();
        const id = a.payload.doc.id;

        const data: IMiembro = {
          key: id,
          nombre_comercial: _data.nombre_comercial,
          razon_social: _data.razon_social,
          rutaImg: _data.rutaImg,
          actividad_economica: _data.actividad_economica,
          website: _data.website,
          organizacion: _data.organizacion,
          fecha: _data.fecha,
          es_activo: _data.es_activo
        };
        return data;
      }))
    );
  }


  getCountryById(refOrg: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.db.doc(refOrg).get().subscribe(re => {
        this.db.doc(re.data().pais).get().subscribe(res => {
          resolve(res.data());
        }, (err) => reject(err));
      }, (err) => reject(err));
    });
  }

  getOrganizacionById(refOrg: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.db.doc(refOrg).get().subscribe(res => {
        const data = {
          key: res.id,
          nombre: res.data().nombre,
          direccion: res.data().direccion,
          logo: res.data().logo,
          telefono: res.data().telefono,
          color: res.data().color,
          pais: res.data().pais,
          es_activo: res.data().es_activo
        };
        resolve(data);
      });
    });
  }

  getUsuarioById(refUser: string) {
    return new Promise((resolve, reject) => {
      this.db.doc(refUser).get().subscribe(res => {
        const data = {
          key: res.id,
          correo: res.data().correo,
          password: res.data().password,
          rutaImg: res.data().rutaImg,
          rol: res.data().rol,
          changePass: res.data().changePass
        };
        resolve(data);
      });
    });
  }

  getUserByEmail(email: string){
    return 
  }

  async updateStatePass(email){
      try {
        const userRef =this.db.collection<IUsuario>('usuarios', ref => ref.where('correo', '==', email));
        let user = await userRef.get().toPromise();
        const userData = user.docs[0].data();
      const data = {
        ...userData,
        changePass: true,
      }
      this.db.collection('usuarios').doc(userData.key).update(data);  
      console.log('si se pudo');
    } catch (error) {
      console.log(`no se pudo ${error}`);
    }
    
 
  }

  getPaisById(refCountry) {
    console.log('id pais', refCountry);

    return new Promise((resolve, reject) => {
      this.db.doc(refCountry).get().subscribe(pais => {
        const country: Paises = {
          key: pais.data().key,
          id: pais.data().id,
          nombre: pais.data().nombre,
          codigoTelefono: pais.data().codigoTelefono,
          estados: pais.data().estados,
        }
        resolve(country);
      });
    });
  }

  getRolById(refRol: string) {
    return new Promise((resolve, reject) => {
      this.db.doc(refRol).get().subscribe(res => {
        const data = {
          key: res.id,
          nombre: res.data().nombre,
          descripcion: res.data().descripcion,
        };
        resolve(data);
      });
    });
  }

  // traer colaboradores
  getColaboradoresById(idMiembro: string): Observable<IColaborador[]> {
    return this.db.collection<IColaborador>('colaboradores').snapshotChanges().pipe(
      map(actions => actions.filter(a => {
        return a.payload.doc.data().miembro === idMiembro;
      }).map(a => {
        const _data = a.payload.doc.data();
        const id = a.payload.doc.id;

        const data: IColaborador = {
          key: id,
          nombre_completo: _data.nombre_completo,
          cargo: _data.cargo,
          telefono_empresarial: _data.telefono_empresarial,
          telefono_celular: _data.telefono_celular,
          usuario: _data.usuario,
          miembro: _data.miembro,
          fecha: _data.fecha,
          enviado_por: _data.enviado_por,
          fecha_enviado: _data.fecha_enviado
        };
        return data;
      }))
    );
  }

  getMiembros(): Observable<IMiembro[]> {
    return this.db.collection<IMiembro>('miembros').snapshotChanges().pipe(
      map(actions => actions.filter(a => {
        return !a.payload.doc.data().es_eliminado;
      }).map(a => {

        const _data = a.payload.doc.data();
        const id = a.payload.doc.id;

        const data: IMiembro = {
          key: id,
          nombre_comercial: _data.nombre_comercial,
          razon_social: _data.razon_social,
          rutaImg: _data.rutaImg,
          actividad_economica: _data.actividad_economica,
          website: _data.website,
          organizacion: _data.organizacion,
          fecha: _data.fecha,
          es_activo: _data.es_activo
        };

        const organizaciones = this.db.doc(data.organizacion).get();
        organizaciones.subscribe(res => {
          data.organizacion = {
            key: res.id,
            nombre: res.data().nombre,
            logo: res.data().logo,
            direccion: res.data().direccion,
            telefono: res.data().telefono,
            color: res.data().color,
            es_activo: res.data().es_activo
          };
        });

        return data;
      })
      )
    );
  }


  getDataValidOrganizacion(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getMiembros().subscribe(res => {
        const dataSend = res && res.filter(async(item) => {
          const verify: any = await this.validarOrganizacion(item.organizacion);
          const { ok } = verify;
          if(ok){
            return item;
          }
        });
        resolve({ data: dataSend });
      });
    });
  }


  validarOrganizacion(refOrg: string) {
    return new Promise((resolve) => {
      this.db.doc(refOrg).get().subscribe((res) => {
        console.log('DATA',res.data());
        if (res) resolve({ ok: false });
        else resolve({ ok: res.data().es_activo });
      });
    });
  }



  // Modificar miembros

  modificarMiembro(miembro: IMiembro) {
    const data = {
      nombre_comercial: miembro.nombre_comercial,
      razon_social: miembro.razon_social,
      website: miembro.website,
      actividad_economica: miembro.actividad_economica,
      rutaImg: miembro.rutaImg,
      organizacion: miembro.organizacion
    };
    return this.db.collection('miembros').doc(miembro.key).update(data);
  }

  // Generar Key
  generarkey() {
    return this.db.createId();
  }
  // Traer todos los roles
  getRoles() {
    return this.db.collection<IRol>('roles').snapshotChanges().pipe(
      map(actions => actions.filter(a => {
        return a.payload.doc.data();
      }).map(a => {
        const _data = a.payload.doc.data();
        const id = a.payload.doc.id;

        const data: IRol = {
          key: id,
          nombre: _data.nombre,
          descripcion: _data.descripcion
        };
        return data;
      }))
    );
  }

  // Eliminar un colaborador
  eliminarColaborador(colaborador: IColaborador): Promise<void> {
    return this.db.collection('colaboradores').doc(colaborador.key).delete();
  }

  // Eliminar Usuario
  eliminarUsuario(usuario: IUsuario): Promise<void> {
    return this.db.collection('usuarios').doc(usuario.key).delete();
  }


  // registrar usuario autenticado por accesos
  registrarAccesos(user, password) {
    // Evita que el usuario recien creado no inicie sesion automaticamente
    const authWorkerApp = this.getFirebaseApp('auth-worker', firebase.app().options);
    const authWorkerAuth = firebase.auth(authWorkerApp);
    authWorkerAuth.setPersistence(firebase.auth.Auth.Persistence.NONE); // disables caching of account credentials
    return authWorkerAuth.createUserWithEmailAndPassword(user, password);
  }

  getFirebaseApp(name, config) {
    const foundApp = firebase.apps.find(app => app.name === name);
    return foundApp ? foundApp : firebase.initializeApp(config || firebase.app().options, 'auth-worker');
  }
  // Traer paises para pintar en el seldct de paises
  traerPaises(): Observable<Paises[]> {
    return this.db.collection<PaisesDB>('paises').snapshotChanges().pipe(
      map(actions => actions.filter(a => {
        return a.payload.doc.data();
      }).map(a => {
        const _data = a.payload.doc.data();
        const id = a.payload.doc.id;

        const data: Paises = {
          key: id,
          id: _data.id,
          nombre: _data.nombre,
          codigoTelefono: _data.codigoTelefono,
          estados: _data.estados,
        };

        return data;
      }))
    );
  }
  // modificar si se envio correo de notificacion
  emailWasSent(colaborador: IColaborador): Promise<void> {
    const data = {
      enviado_por: colaborador.enviado_por,
      fecha_enviado: colaborador.fecha_enviado
    }
    return this.db.collection('colaboradores').doc(colaborador.key).update(data);
  }

  // Crear un miembro
  crearMiembro(miembro: IMiembro): Promise<void> {
    const doc = this.db.collection('miembros').doc(miembro.key);
    return doc.set({ ...miembro });
  }
  // Crear un colaborador
  crearColaborador(colaborador: IColaborador): Promise<void> {
    const doc = this.db.collection('colaboradores').doc(colaborador.key);
    return doc.set({ ...colaborador });
  }
  // Crear un usuario
  crearUsuario(usuario: IUsuario): Promise<void> {
    const doc = this.db.collection('usuarios').doc(usuario.key);
    return doc.set({ ...usuario });
  }


  // Modificar un colaborador
  modificarColaborador(colaborador: IColaborador) {
    const data = {
      nombre_completo: colaborador.nombre_completo,
      cargo: colaborador.cargo,
      telefono_celular: colaborador.telefono_celular,
      telefono_empresarial: colaborador.telefono_empresarial,
      es_activo: true,
      fecha: colaborador.fecha
    };
    return this.db.collection('colaboradores').doc(colaborador.key).update(data);
  }
  // Modificar un Usuario
  modificarUsuario(usuario: IUsuario) {
    let data;
    if (usuario.rutaImg) {
      data = {
        rol: usuario.rol,
        rutaImg: usuario?.rutaImg
      };
    } else {
      data = {
        rol: usuario.rol,
      };
    }
    console.log(data);

    return this.db.collection('usuarios').doc(usuario.key).update(data);
  }
  // ELiminar empresa esxistente
  eliminarMiembro(miembro: IMiembro): Promise<void> {
    const data = {
      es_eliminado: miembro.es_eliminado,
      eliminado_por: miembro.eliminado_por,
      es_activo: miembro.es_activo,
      fecha_eliminado: miembro.fecha_eliminado
    };
    return this.db.collection('miembros').doc(miembro.key).update(data);
  }
  // Descativar empresa
  desactivarEmpresa(miembro: IMiembro): Promise<void> {
    return this.db.collection('miembros').doc(miembro.key).update({ es_activo: false });
  }
  // Activar una empresa
  activarEmpresa(miembro: IMiembro): Promise<void> {
    return this.db.collection('miembros').doc(miembro.key).update({ es_activo: true });
  }


  /**
    * Check if the user is a member
    * @param {string} email user email.
    */
  verifyLogin(email: string, rolSuperAdmin: string, rolAdmin: string,miembroAdmin: string,miembro: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.db.collection('usuarios', ref => ref.where('correo', '==', email)).snapshotChanges().subscribe(async (dataUser) => {
        const key = Object.keys(dataUser).length;
        
        if (!key) resolve({ ok: false });
        else {
          const dataUserC: any = dataUser.map((a: any) => {
            return a.payload.doc.data();
          });
          const { rol: refRol } = dataUserC[0];
          this.db.doc(refRol).get().subscribe((a: any) => {
            if (a.data().nombre === rolSuperAdmin || a.data().nombre === rolAdmin || a.data().nombre === miembroAdmin || a.data().nombre === miembro) resolve({ ok: true });
            else resolve({ ok: false });
          });
        }
      }, (e) => {
        reject(e);
      });
    });
  }


}
